function CallToAction() {
    return (
        <a href="tel:+917823946731 " className="action-button shadow-lg"> <i className="fa fa-phone"></i> Call Us </a>
    )
}
 
export default CallToAction 